import { atom, useRecoilState, useResetRecoilState } from 'recoil';

/**
 * BU 목록
 */
// atom
const buState = atom({
  key: 'buState',
  default: []
});

// hook
function useBUState() {
  const [bu, setBU] = useRecoilState(buState);
  const resetBU = useResetRecoilState(buState);

  return {
    bu,
    setBU,
    resetBU
  };
}

export default useBUState;
